import {
  CLOSED_NOTEHEAD_PATH,
  OPEN_NOTEHEAD_PATH,
  WHOLE_NOTEHEAD_PATH
} from "./../staff/noteheadPaths";

import {
  SHARP_PATH,
  FLAT_PATH,
  DOUBLE_SHARP_PATH,
  DOUBLE_FLAT_PATH,
  NATURAL_PATH
} from "./../staff/accidentalPaths";

import {
  QUARTER_REST_PATH,
  HALF_REST_PATH,
  WHOLE_REST_PATH,
  EIGHTH_REST_PATH,
  SIXTEENTH_REST_PATH,
  THIRTY_SECOND_REST_PATH
} from "./../staff/restPaths";

import {
  EIGHTH_FLAG_PATH,
  SIXTEENTH_FLAG_PATH,
  THIRTY_SECOND_FLAG_PATH
} from "./../staff/flagPaths";

export const NOTEHEADS = {
  whole_note: WHOLE_NOTEHEAD_PATH,
  half_note: OPEN_NOTEHEAD_PATH,
  dotted_half_note: OPEN_NOTEHEAD_PATH,
  quarter_note: CLOSED_NOTEHEAD_PATH,
  eighth_note: CLOSED_NOTEHEAD_PATH,
  sixteenth_note: CLOSED_NOTEHEAD_PATH,
  thirty_second_note: CLOSED_NOTEHEAD_PATH
};

export const FLAGS = {
  eighth_note: EIGHTH_FLAG_PATH,
  sixteenth_note: SIXTEENTH_FLAG_PATH,
  thirty_second_note: THIRTY_SECOND_FLAG_PATH
};

export const RESTS = {
  quarter_rest: QUARTER_REST_PATH,
  dotted_quarter_rest: QUARTER_REST_PATH,
  half_rest: HALF_REST_PATH,
  whole_rest: WHOLE_REST_PATH,
  eighth_rest: EIGHTH_REST_PATH,
  sixteenth_rest: SIXTEENTH_REST_PATH,
  thirty_second_rest: THIRTY_SECOND_REST_PATH
};

export const ACCIDENTALS = {
  "#": SHARP_PATH,
  b: FLAT_PATH,
  x: DOUBLE_SHARP_PATH,
  ff: DOUBLE_FLAT_PATH,
  n: NATURAL_PATH
};

export const FLAG_CONFIG = {
  eighth_note: {
    translate: "translate(11.9,-35.5)",
    scale: (stemUp, s) => `scale(${s}, ${s})`
  },
  sixteenth_note: {
    translate: "translate(11.9,-35.5)",
    scale: (stemUp, s) => `scale(${s}, ${-s})`
  },
  thirty_second_note: {
    translate: "translate(11.9,-35.5)",
    scale: (stemUp, s) => `scale(${s}, ${-s})`
  }
};

export const NOTEHEAD_SCALE = 0.035;
export const REST_SCALE = 0.035;
export const FLAG_SCALE = 0.03;
